import { UnknownAction } from 'redux';

export const SET_SEARCH = 'SET_SEARCH';

export interface SearchFilterAction extends UnknownAction {
  searchFilterText?: string;
}

export function searchFilterTextAction(searchFilterText?: string): SearchFilterAction {
  return {
    type: SET_SEARCH,
    searchFilterText,
  };
}
